import { render, staticRenderFns } from "./infiniteLoadData.vue?vue&type=template&id=383f2d12&scoped=true&"
import script from "./infiniteLoadData.vue?vue&type=script&lang=js&"
export * from "./infiniteLoadData.vue?vue&type=script&lang=js&"
import style0 from "./infiniteLoadData.vue?vue&type=style&index=0&id=383f2d12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f2d12",
  null
  
)

export default component.exports